import { EmployeeRole } from "../../appointment-details.types.js";
const LABEL_OFFSET = 50;
const MIN_DURATION = 10;
const EMPLOYEE_ROLES = [EmployeeRole.DENTIST, EmployeeRole.HYGIENIST];
export {
  EMPLOYEE_ROLES,
  LABEL_OFFSET,
  MIN_DURATION
};
